import * as React from 'react';
import {
    ChartHoverCard,
    DonutChart,
    IChartProps,
    IChartDataPoint,
    DataVizPalette,
    getColorFromToken,
    MultiStackedBarChart,
    StackedBarChart,
} from '@fluentui/react-charting';

// styles
import './SettlementMoneyChart.Styles.css';

// functions
import * as ComponentFunctions from './SettlementMoneyChart.Functions';
import { connect } from 'react-redux';
import { Label } from '@fluentui/react';

const SettlementMoneyChartComponent = (props: ComponentFunctions.Props) => {

    const points: IChartDataPoint[] = React.useMemo(() => [
        {
            legend: 'Por cobrar',
            data: props.OwnerAmount || 0,
            color: getColorFromToken(DataVizPalette.color6),
            xAxisCalloutData: 'Por cobrar',
            callOutAccessibilityData: { ariaLabel: 'Por cobrar: ' + (props.OwnerAmount || 0).toLocaleString('us-US', { style: 'currency', currency: props.CurrencyCode.toUpperCase() }) },
        }
    ], [props.OwnerAmount, props.CurrencyCode]);

    React.useEffect(() => {
        if((props.TeamAmount || 0) > 0) {
            points.push({
                legend: 'Equipo medico',
                data: props.TeamAmount || 0,
                color: getColorFromToken(DataVizPalette.color3),
                xAxisCalloutData: 'Equipo medico',
                callOutAccessibilityData: { ariaLabel: 'Equipo medico: ' + (props.TeamAmount || 0).toLocaleString('us-US', { style: 'currency', currency: props.CurrencyCode.toUpperCase() }) },
            });
        }
    }, [points, props.CurrencyCode, props.TeamAmount]);

    React.useEffect(() => {
        if((props.TotalWithholdings || 0) > 0) {
            points.push({
                legend: 'withholding',
                data: props.TotalWithholdings || 0,
                color: getColorFromToken(DataVizPalette.color7),
                xAxisCalloutData: 'withholding',
                callOutAccessibilityData: {
                    ariaLabel: 'Withholding: ' + (props.TotalWithholdings || 0).toLocaleString('es-AR', { style: 'currency', currency: props.CurrencyCode.toUpperCase() })
                },
            });
        }
    }, [points, props.CurrencyCode, props.TotalWithholdings]);

    React.useEffect(() => {
        if((props.TotalToSettle || 0) > 0) {
            points.push({
                legend: 'Total',
                data: props.TotalToSettle || 0,
                color: getColorFromToken(DataVizPalette.color4),
                xAxisCalloutData: 'Total',
                callOutAccessibilityData: { ariaLabel: 'Total:' + (props.TotalToSettle || 0).toLocaleString('es-AR', { style: 'currency', currency: props.CurrencyCode.toUpperCase() }) },
            });
        }
    }, [points, props.CurrencyCode, props.TotalToSettle]);

     const data: IChartProps = {
        chartTitle: props.CurrencyCode.toUpperCase(),
        chartData: points,
    };

    return (
        <div className='CurrencyCart'>
            {props.ChartType === ComponentFunctions.CharType.Donut && 
            <DonutChart
                data={data}
                innerRadius={60}
                legendsOverflowText={'Total'}
                hideLegend={false}
                height={220}
                width={176}
                valueInsideDonut={((props.TotalToSettle || 0) - (props.TotalWithholdings || 0) || 0)}
                // eslint-disable-next-line react/jsx-no-bind
                onRenderCalloutPerDataPoint={(props: IChartDataPoint | undefined) =>
                    props ? (
                        <ChartHoverCard
                            XValue={props.xAxisCalloutData || ''}
                            Legend={'valor'}
                            YValue={`${props.yAxisCalloutData || props.data?.toLocaleString('es-AR', { style: 'currency', currency: 'USD' })}`}
                            color={getColorFromToken(DataVizPalette.highSuccess)}
                        />
                    ) : null
                }
            />}
            {props.ChartType === ComponentFunctions.CharType.Line &&
            <StackedBarChart 
                data={data}
                width={600}
                enabledLegendsWrapLines={true}
                href={'https://developer.microsoft.com/en-us/'}
                onRenderCalloutPerDataPoint={(props: IChartDataPoint | undefined) =>
                    props ? (
                        <ChartHoverCard
                            XValue={props.xAxisCalloutData || ''}
                            Legend={'valor'}
                            YValue={`${props.yAxisCalloutData || props.data?.toLocaleString('us-US', { style: 'currency', currency: 'USD' })}`}
                            color={getColorFromToken(DataVizPalette.highSuccess)}
                        />
                    ) : null
                }
            />}
        </div>
    );
}

export default connect(
    ComponentFunctions.mapStateToProps,
    ComponentFunctions.mapDispatchToProps
)(SettlementMoneyChartComponent as any)
